import React from 'react';
import styled from 'styled-components';
import { useChangeSetPreview } from 'features/ChangeSetPreview';

const PREVIEWING = 'Previewing a draft';
const GONE =
  'This draft is no longer available. Showing the published storefront.';

/**
 * A slim bar across the top of the embed while a change set is being previewed. It cannot be
 * dismissed: everything under it is a draft that nobody else can see, and nothing else on the
 * page says so. When the service stops answering for the set, the storefront below has already
 * fallen back to the published one, so the bar stays and says that instead of letting the page
 * change under the reader in silence.
 */
const DraftPreviewBanner = () => {
  const { changeSetId, isUnavailable } = useChangeSetPreview();

  if (!changeSetId && !isUnavailable) return null;

  return <Banner role="status">{isUnavailable ? GONE : PREVIEWING}</Banner>;
};

const Banner = styled.div`
  position: sticky;
  top: 0;
  z-index: 20;
  padding: 8px 16px;
  border-bottom: 1px solid var(--way-colors-borderColor);
  background-color: var(--way-palette-black-5);
  color: var(--way-colors-primaryTextColor);
  text-align: center;
`;

export default DraftPreviewBanner;
